import { create } from "zustand";
import { financeApi } from "../api_layer/api";

const useFinanceStore = create((set) => ({
  financeData: [],
  cancelData:[],
  rtoData:[],
  isLoading: false,
  cancelLoading:false,
  rtoLoading:false,
  error: null,
  fetchFinanceData: async (payload) => {
    try {
      set({ isLoading: true, error: null });
      const response = await financeApi(payload);
      set({ financeData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  fetchCancelData: async (payload) => {
    try {
      set({ cancelLoading: true, error: null });
      const response = await financeApi(payload);
      set({ cancelData: response.data, cancelLoading: false });
    } catch (error) {
      set({ error: error.message, cancelLoading: false });
    }
  },
  fetchRtoData: async (payload) => {
    try {
      set({ rtoLoading: true, error: null });
      const response = await financeApi(payload);
      set({ rtoData: response.data, rtoLoading: false });
    } catch (error) {
      set({ error: error.message, rtoLoading: false });
    }
  },
}));

export default useFinanceStore;